(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FirstNameDetailController', FirstNameDetailController);

    FirstNameDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FirstName'];

    function FirstNameDetailController($scope, $rootScope, $stateParams, entity, FirstName) {
        var vm = this;
        vm.firstName = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:firstNameUpdate', function(event, result) {
            vm.firstName = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
